/** @jsx jsx */
import { jsx, Badge as BadgeThemeUi } from "theme-ui"
import * as styles from "./styles"
import React from "react"

interface BadgeProps {
  children: React.ReactNode
  circle?: boolean
  className?: string
  variant?: BadgeVariant
}

export enum BadgeVariant {
  MUTED = "muted",
  SUCCESS = "success",
  WARNING = "warning",
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  circle,
  className,
  variant = BadgeVariant.MUTED,
}) => (
  <BadgeThemeUi
    className={className}
    variant={variant}
    sx={styles.root}
    circle={circle}
  >
    {children}
  </BadgeThemeUi>
)
